<template>
  <section class="contact d-flex align-center">
    <div class="content" :class="{'no-p': hasPadding}">
      <h2 class="big-title big-title--no-p">لنتعرف</h2>
      <p>
        <moving-words>
          لا تتردد بالتواصل معنا سواء كنت مهتما بالعمل معنا، شرب كوب من القهوة، التحدث عن الأفلام أو حتى إلقاء التحية.
        </moving-words>
      </p>
      <router-link :to="{ name: 'Contact' }" class="btn btn--outline btn--primary">
        تواصل معنى الآن
      </router-link>
    </div>
  </section>
</template>

<script>
import MovingWords from '@/components/MovingWords'

export default {
  props: {
    hasPadding: {
      type: Boolean,
      default: true
    }
  },
  components: {
    MovingWords
  }
}
</script>

<style lang="scss">
.contact {
  padding: 2rem;
  h3 {
    padding-right: 5rem;
  }

  p {
    max-width: 500px;

    @media screen and (min-width: 1440px) {
      max-width: 700px;
    }
  }

  .words {
    line-height: 1.5;
  }

  .content {
      @media screen and (min-width: 960px) {
      margin-top: 0;
      padding: 0 12rem;
    }
    &.no-p {
      padding: 0;
    }
  }
}
</style>
